// extracted by mini-css-extract-plugin
module.exports = {"floatingBtn":"FloatingApplyButton_floatingBtn__nE_gV","pulse":"FloatingApplyButton_pulse__sj9ZG"};